import { HsMedia } from '@hsetu/ngui-components';
import { Media } from '../models/media.model';

export class MediaMapper {
  public mapPutMediaRequest(data: Media) {
    const request = {
      UId: data.uId,
      OwnerKey: data.ownerKey,
      InfoDesc: data.infoDesc,
      LongDesc: data.longDesc,
      MimeType: data.mimeType,
      Type: data.type,
      Content: data.content,
    };
    return request;
  }

  public mapToHsMedia(data: Media): HsMedia {
    return {
      uId: data.uId,
      name: data.infoDesc || '',
      stampCreate: data.stampCreate,
      thumbnail: data.content,
      stampEdit: data.stampEdit,
      type: data.type,
    };
  }
}
